import { useEffect, useState } from "react";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaUsers, FaUserPlus, FaUserTie } from 'react-icons/fa';

export default function Traffic() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [traffic, setTraffic] = useState([]);

  useEffect(() => {
    const fetchTraffic = async () => {
      if (!token) {
        navigate("/");
      }

      try {
        const response = await axios.get("https://artofbetting.gr/api/traffic", {
          headers: {
            "Authorization": token,
          }
        });
        setTraffic(response.data);
      } catch (error) {
        if (error.response?.status === 401) {
          alert(translations.alertTokenExpired);
          // Redirect στο home
          localStorage.removeItem("token");
          navigate("/");
        }
        else if (error.response?.status === 403) {
          navigate("/");
        }
        else if (error.response?.status === 404) {
          alert("Προέκυψε κάποιο θέμα, παρακαλώ προσπαθήστε ξανά.")
        }
      }
    };

    fetchTraffic();
  }, [token, navigate, translations.alertTokenExpired]);

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      <header className="flex justify-between items-center p-4 bg-gray-800 mb-6 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      <main className="mt-6">
        <div className="grid grid-cols-2 md:grid-cols-6 bg-gray-800 p-6 rounded-lg shadow-lg gap-4">
          {/* Επισκέψεις Σήμερα */}
          <div className="flex flex-col items-center">
            <div className="flex items-center text-white mb-2">
              <FaEye className="text-2xl mr-2" />
              <h2 className="text-2xl font-bold">Σήμερα</h2>
            </div>
            <button className="bg-green-800 text-white py-2 px-6 rounded-lg hover:bg-green-700 transition duration-300">
              {traffic.today_visits}
            </button>
          </div>

          {/* Άτομα Σήμερα */}
          <div className="flex flex-col items-center">
            <div className="flex items-center text-white mb-2">
              <FaUsers className="text-2xl mr-2" />
              <h2 className="text-2xl font-bold">Σήμερα</h2>
            </div>
            <button className="bg-green-800 text-white py-2 px-6 rounded-lg hover:bg-green-700 transition duration-300">
              {traffic.unique_today_ips}
            </button>
          </div>

          {/* Επισκέψεις Χθες */}
          <div className="flex flex-col items-center">
            <div className="flex items-center text-white mb-2">
              <FaEye className="text-2xl mr-2" />
              <h2 className="text-2xl font-bold">Χθες</h2>
            </div>
            <button className="bg-green-800 text-white py-2 px-6 rounded-lg hover:bg-green-700 transition duration-300">
              {traffic.yesterday_visits}
            </button>
          </div>

          {/* Άτομα Χθες */}
          <div className="flex flex-col items-center">
            <div className="flex items-center text-white mb-2">
              <FaUsers className="text-2xl mr-2" />
              <h2 className="text-2xl font-bold">Χθες</h2>
            </div>
            <button className="bg-green-800 text-white py-2 px-6 rounded-lg hover:bg-green-700 transition duration-300">
              {traffic.unique_yesterday_ips}
            </button>
          </div>

          {/* Εγγραφές */}
          <div className="flex flex-col items-center">
            <div className="flex items-center text-white mb-2">
              <FaUserPlus className="text-2xl mr-2" />
              <h2 className="text-2xl font-bold">Χρήστες</h2>
            </div>
            <button className="bg-green-800 text-white py-2 px-6 rounded-lg hover:bg-green-700 transition duration-300">
              {traffic.total_users}
            </button>
          </div>

          {/* Συνδρομές */}
          <div className="flex flex-col items-center">
            <div className="flex items-center text-white mb-2">
              <FaUserTie className="text-2xl mr-2" />
              <h2 className="text-2xl font-bold">VIP</h2>
            </div>
            <button className="bg-green-800 text-white py-2 px-6 rounded-lg hover:bg-green-700 transition duration-300">
              {traffic.active_subscriptions}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
